import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const HelpDeskReport = React.lazy(() => import("@/pages/heplDeskReport/Index"));

const HelpDesk = [
  {
    path: "helpDeskReport",
    element: (
      <SuspenseWrapper>
        <HelpDeskReport />
      </SuspenseWrapper>
    ),
  }
];

export default HelpDesk;
